import { AspectRatioRounded, ControlPointOutlined } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import useAspectRatio from '../../../../hooks/useAspectRatio';
import { addNewAsset } from '../../../../store/actions/assets';

const AssetListControls = () => {
  const dispatch = useDispatch();
  const handleAspectRatio = useAspectRatio();
  const { preferences } = useSelector((state) => state.currentUser);

  const handleAddToAssetTypes = () => {
    dispatch(addNewAsset());
  };

  return (
    <Box>
      <IconButton
      edge="end"
      onClick={handleAddToAssetTypes}
    >
      <ControlPointOutlined />
      </IconButton>
      <IconButton
        edge="end"
        onClick={() => {
          handleAspectRatio(!preferences.aspectChanged);
        }}
        sx={{ marginLeft: 2, marginRight: '1px' }}
      >
        <AspectRatioRounded />
      </IconButton>
    </Box>
  );
};

export default AssetListControls;
